import React from "react";
import { Col, Row, Form, Checkbox, Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import "../style.css";
import { useDispatch, useSelector } from "react-redux";
import { setLandCoverSelections } from "../../../Redux/filterSlice";
import { allCoverTypes } from "../../../Common/constants";

const CheckboxGroup = Checkbox.Group;
function Step2() {
  const dispatch = useDispatch();
  const { landCoverSelections } = useSelector((state) => state.filter);

  return (
    <>
      <Row>
        <Col className="mt-3">
          <div>
            <b>
              2) Does your land you are considering for CRP
              enrollment/reenrollment include any of the following cover types?{" "}
            </b>
          </div>
        </Col>
      </Row>
      <Form>
        <Row gutter={40} className="mt-3 checkbox-list">
          <CheckboxGroup
            className="checkbox-group land-cover-tutorial"
            value={landCoverSelections}
            onChange={(checkedValues) =>
              dispatch(setLandCoverSelections(checkedValues))
            }
          >
            {allCoverTypes.map((priority) => {
              return (
                <Checkbox className="checkbox-container" value={priority.value}>
                  <img
                    className="checkbox-image"
                    src={priority.src}
                    alt={priority.alt}
                  />
                  <Popover
                    overlayStyle={{
                      maxWidth: "20vw",
                    }}
                    placement="topRight"
                    content={priority.qContent}
                    trigger="hover"
                  >
                    <span className="pa">
                      <QuestionCircleOutlined />
                    </span>
                  </Popover>
                  <div className="checkbox-label">{priority.label}</div>
                </Checkbox>
              );
            })}
          </CheckboxGroup>
        </Row>
      </Form>
    </>
  );
}
export default Step2;
